import { useState } from 'react'

/**
 * 대본 파싱 로직을 위한 커스텀 훅
 */
function useScriptParser() {
  const [title, setTitle] = useState('')
  const [script, setScript] = useState('')

  const parseScript = (addSections, setTitleSettings) => {
    if (!script.trim()) return

    // 구간 분리 시에는 제목 자동 적용 안 함
    // 사용자가 '적용' 버튼을 명시적으로 클릭해야 제목이 적용됨

    // 줄바꿈 기준으로 구간 분리
    const lines = script
      .split('\n')
      .filter(line => line.trim())
    
    // UUID 생성 함수 (브라우저 내장 API 사용)
    const generateUUID = () => {
      if (crypto.randomUUID) {
        return crypto.randomUUID()
      }
      // 폴백: 간단한 UUID v4 생성
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
    
    // 대본 내용으로 섹션 생성
    const newSections = lines
      .map((text, index) => ({
        id: generateUUID(), // UUID 사용
        index: index + 1,  // 1부터 시작하는 구간 번호
        text: text.trim(),
        imageFile: null,
        videoFile: null,
        urlMedia: '',
        isTitle: false  // 일반 섹션
      }))

    addSections(newSections)
  }

  return {
    title,
    setTitle,
    script,
    setScript,
    parseScript
  }
}

export default useScriptParser